import { ProviderData, StateData } from '@/common/types';
import { useLoaderData } from 'react-router-dom';

const NoResultsFoundMessage = ({
  providers,
  selectedStateCode,
  selectedInsurance,
}: {
  providers: ProviderData[];
  selectedStateCode: string | null;
  selectedInsurance: string | null;
}) => {
  const { states } = useLoaderData() as {
    states: StateData[];
  };

  const shouldRender =
    providers.length === 0 &&
    selectedStateCode !== null &&
    selectedInsurance !== null;

  if (!shouldRender) return null;

  const stateName = states.find(
    (state) => state.code === selectedStateCode
  )?.displayName;

  return (
    <div
      className="bg-light-subtle border border-warning rounded p-4 mb-4 text-center"
      style={{ maxWidth: '100%' }}
    >
      <h5 className="fw-bold mb-2">No Results</h5>
      <p className="mb-1">
        No providers found
        {stateName && (
          <>
            {' in '}
            <span className="badge bg-primary">{stateName}</span>
          </>
        )}
        {selectedInsurance && (
          <>
            {' that take '}
            <span className="badge bg-primary">{selectedInsurance}</span>
            {' insurance'}
          </>
        )}
        .
      </p>
      <p className="text-muted">
        Please make a new selection to find an available provider.
      </p>
    </div>
  );
};

export default NoResultsFoundMessage;
